var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.globalState === _vm.GS.INIT)?_c('div',{staticClass:"comp-start"},[_c('el-button',{staticClass:"start-btn",attrs:{"type":"primary","size":"large"},on:{"click":_vm.startGame}},[_vm._v("Start")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }